<div class="nexleader-bar-chart-wrapper">
  <canvas #chartCanvas></canvas>
</div>
